import { render, staticRenderFns } from "./HeaderStyle.vue?vue&type=template&id=780c2744&"
import script from "./HeaderStyle.vue?vue&type=script&lang=js&"
export * from "./HeaderStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports